const state = {
  aliveStep: 0,
  addSurvy: false,
  addTemplate: false,

  isQuoted: true,
  connectSurveyId: ''
}

const mutations = {
  commonMutations: (state, payload) => {
    Object.keys(payload).forEach(item => {
      state[item] = payload[item]
    })
  },
  initPage: (state, payload) => {
    state.aliveStep = 0
    state.addSurvy = false
    state.addTemplate = false
    // state.isQuoted = true
    // state.connectSurveyId = ''
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
